import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from '@tanstack/react-query';
import { USER_QUERY_KEYS } from './keys';
import { fetchUserList, fetchApprovers, getUserData } from './services';
import type {
  IUserDropdownResponse,
  IUserListParams,
  IUser,
} from 'types/User/user';

export const useUserListQuery = (
  params?: IUserListParams,
): UseQueryResult<IUserDropdownResponse> =>
  useQuery({
    queryKey: [USER_QUERY_KEYS.GET_USERS, params],
    queryFn: () => fetchUserList(params),
    refetchOnWindowFocus: false,
    retry: false,
  });

export const useApproversQuery = (): UseQueryResult<IUserDropdownResponse> =>
  useQuery({
    queryKey: [USER_QUERY_KEYS.GET_APPROVERS],
    queryFn: fetchApprovers,
    refetchOnWindowFocus: false,
    retry: false,
  });

export const useGetUserDataQuery = (
  options?: Omit<UseQueryOptions<IUser, Error>, 'queryKey' | 'queryFn'>,
) =>
  useQuery({
    queryKey: [USER_QUERY_KEYS.GET_USER_DATA],

    queryFn: getUserData,
    ...options,
  });
